const CONSTANT = {
    URL_CHECK_VALIDATION_MEMBER_PERSON: '/member/check-validation-person',
    URL_CHECK_VALIDATION_MEMBER_UPDATE_PERSON: '/member/check-validation-update-person',
    URL_CHECK_VALIDATION_MEMBER_COMPANY: '/member/check-validation-company',
    URL_CHECK_VALIDATION_MEMBER_UPDATE_COMPANY: '/member/check-validation-update-company',
    URL_CHECK_VALIDATION_BID_MEMBER_PERSONAL: '/member/bid/check-validation-bid-personal',
    URL_CHECK_VALIDATION_BID_MEMBER_COMPANY: '/member/bid/check-validation-bid-company',
    URL_CREATE_MEMBER_PERSON: '/member/create-member-person',
    URL_CREATE_MEMBER_COMPANY: '/member/create-member-company',
    URL_DUPLICATE_PRODUCT: '/admin/product/duplicate-product',
    URL_IMPORT_PRODUCT: '/admin/product/import',
    URL_PRODUCT_TOP: '/admin/product',
    URL_CHECK_VALIDATION_AUCTION: '/admin/auction/check-validation',
    URL_CHECK_VALIDATION_PRODUCT: '/admin/product/check-validation',
    URL_CHECK_VALIDATION_MEMBER_UPDATE: '/admin/member/check-validation-update',
    URL_CHECK_VALIDATION_MEMBER_CREATE: '/admin/member/check-validation-create',
    URL_CREATE_NOTE_PRODUCT: '/member/storeProductNote',
    URL_IMPORT_AUCTION_PRODUCT_END_BID_TIME: '/admin/auction/import-product-end-bid-time',
}

const COMMON = (function () {
    let modules = {};

    modules.callApi = function (url, type, datatype, data) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        const config = datatype === 'JSON' ? {
            url: url,
            type: type,
            dataType: datatype,
            data: data,
        } : {
            url: url,
            type: type,
            data: data,
            contentType: false,
            processData: false
        }
        return $.ajax(config);
    }

    modules.showError = function (err, element) {
        return err ? $(element).empty().append(err.shift()) : '';
    }

    modules.formatIndex = function (errors) {
        for (let key in errors) {
            if (key.includes('.')) {
                let newKey = key.replace(/\./g, "_");
                errors[newKey] = errors[key];
                delete errors[key];
            }
        }
        return errors;
    }

    return modules;
})(window.jQuery, window, document);

$(document).ready(function () {

});

export {COMMON, CONSTANT};
